import { array, literal, object, string } from "superstruct";

import type { PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import {
    EmailDetailSchema,
    EmailListItemSchema,
    RecipientSchema,
    SendEmailSchema,
} from "../models/Email.js";
import { type User } from "../models/User.js";

export default function buildBriefRouter(base: EndpointRouter<PathParamsBase, { user: User }>) {
    const router = base.addRouter(new EndpointRouter());

    const endpoints = {
        getEmailsEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/mailing/emails", object({}))
                .setResultParser(array(EmailListItemSchema)),
        ),
        getEmailEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/mailing/emails/:email", object({ email: string() }))
                .setResultParser(EmailDetailSchema),
        ),
        searchEmailRecipientsEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/mailing/recipients", object({}))
                .setResultParser(array(RecipientSchema))
                .setQueryParamsSchema(object({ search: string() })),
        ),
        sendEmailEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/mailing/emails", object({}))
                .setResultParser(literal(null))
                .setBodySchema(SendEmailSchema),
        ),
    };

    return { router, endpoints };
}
